var map = {
	"./360ed.png": "8LQr",
	"./bangkok-vanguards.png": "hnLp",
	"./bayin.png": "Tcab",
	"./classic-education-centre.png": "ZiF3",
	"./draper-startup-house.png": "/bet",
	"./future-glory.png": "95nq",
	"./geneva-business-school.png": "hBQZ",
	"./grassroot-innovation.png": "uz2H",
	"./klenic.png": "bYLT",
	"./mayday-city.png": "SAbz",
	"./mickeys-real-wood.png": "/he3",
	"./milsciences.png": "+OFV",
	"./myancare.png": "CuSC",
	"./natural-farm-fresh-myanmar.png": "W8TP",
	"./one-to-watch.png": "wCpj",
	"./pro-niti-travel.png": "Vk/B",
	"./recycle-myanmar.png": "acVz",
	"./refill-station.png": "XvPy",
	"./rise-impact.png": "mDn0",
	"./rotterdam-business-school.png": "NieA",
	"./seedstars-academy.png": "Qejk",
	"./social-health-enterprise.png": "9/dW",
	"./sunda-outdoor.png": "35g/",
	"./thammasat-university.png": "XMi7",
	"./visionear.png": "7M2F",
	"./wayha.png": "xvb9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OzVj";